<template>
    <div id="user_info">
        <div class="infos" v-if="isLoaded">
            <div class="main_info" :style="{color: colors.fourth}">
                <span>{{enrollment.name}}</span>
            </div>

            <infoTitle class="others" :userInfos="enrollment" :prop="false"></infoTitle>
            
            <router-link to="edit-user-info">
                <div class="btn rounded" 
                    :style="{background: `linear-gradient(to right, ${colors.thirth} 0%, ${colors.first} 50%, ${colors.fourth} 100%)`}">
                    editar
                </div>
            </router-link>
        </div>
        <Loader v-if="!isLoaded"></Loader>
    </div>    
</template>

<script>
import infoTitle from './InfoTitle'
import Modal from '../../components/modals/Modal'
import Loader from '../../components/Loaders/LoaderFull'

export default {
    name: 'user-info',
    components: {
        infoTitle,
        modal: Modal,
        Loader
    },

    data: () =>({
        colors: '',
        isLoaded: false,
        userInfos: [],
        userInfosTitles: [],
        enrollment: '',
        userInfosTitlesObj: {
            "name":{
                "translation": "Nome"
            },
            "cpf":{
                "translation": "CPF"
            },
            "email":{
                "translation": "E-mail"
            },
            "phone":{
                "translation":"Telefone"
            },
            "age":{
                "translation":"Idade"
            },
            "enrollmentCity":{
                "translation": "Cidade de interesse"
            },
            "address":{
                "translation": "Endereço",
                "cep":{
                    "translation":"CEP"
                },
                "complement":{
                    "translation":"Complemento"
                },
                "neighborhood":{
                    "translation":"Bairro"
                },
                "state":{
                    "translation":"Estado"
                },
                "street":{
                    "translation":"Rua"
                },
            },
            "graduation":{
                "translation": "Graduação",
                "semester":{
                "translation":"Semestre"
                },
                "period":{
                    "translation":"Período"
                },
                "startLesson":{
                    "translation":"Horário de início",
                },
                "endLesson":{
                    "translation":"Horário de término",
                },
                "conclusion":{
                    "translation":"Conclusão"
                },
                "course":{
                    "translation":"Curso"
                },
                "university":{
                    "translation":"Universidade"
                },
                "type":{
                    "translation":"Tipo",
                },
            },
            "language":{
                "translation": "Idioma",
                "english":{
                    "translation":"Inglês"
                },
            }
        },
    }),

    async mounted(){
        this.colors = this.$store.getters.getCustomColors
        let localEnrollment = JSON.parse(localStorage.getItem('enrollment'))
        let loginInfos = this.$store.getters.getUserInfo
        console.log('localEnrollment: ', localEnrollment)
        console.log('loginInfos: ', loginInfos)
        if(!localEnrollment){
            console.log('ENTROU')
            try {
                let enrollmentReq = await this.$http.get(`${process.env.VUE_APP_HOST_FUNCTIONS_CHATBOT}/enrollments?noContext=true&email=${loginInfos.email}`)
                console.log('enrollment Req by email: ', enrollmentReq.body)
                this.enrollment = enrollmentReq.body[0]
                console.log("User Infos: ", this.enrollment)
                localStorage.setItem('enrollment', JSON.stringify(this.enrollment))
                return this.isLoaded = true
            } catch (error) {
                console.error('Erro ao pegar a inscrção: ', error)
                return
            }
        }
        // console.log('enrollment id: ', loginInfos.id)
        this.getEnrollment(localEnrollment.id)
    },

    computed:{

    },
    methods:{
        async getEnrollment(enrollmentId){
            try {
                let enrollmentReq = await this.$http.post(`${process.env.VUE_APP_HOST_FUNCTIONS_CHATBOT}/enrollments/${enrollmentId}`)
                console.log('enrollmentReq: ', enrollmentReq.body)
                this.enrollment = enrollmentReq.body
                localStorage.setItem('enrollment', JSON.stringify(this.enrollment))
                this.isLoaded = true
            } catch (error) {
                console.error('Erro na requisição de inscrição: ', error);
            }
        },
    }
}
</script>

<style lang="scss">
    #user_info{
        
        .infos{
            height: 80vh;
            overflow-y: scroll;
            overflow-x: hidden;
            padding: 32px;

            a{
                text-decoration: none;
            }

            .main_info{
                font-size: 36px;
                letter-spacing: 4px;
                font-weight: 100;
                line-height: 45px;
                margin: 0 0 32px 0;
            }

            .others{
                display: flex;
                flex-direction: column;
                margin: 0 0 32px;

                span{
                    text-transform: uppercase;
                    letter-spacing: 4px;
                    font-size: 12px;
                    margin: 0 0 15px;
                }
                strong{
                    font-weight: 700;
                    letter-spacing: 1.5px;
                }
            }
        }

        .btn{
            display: flex;
            align-items: center;
            justify-content: center;

            &:hover{
                cursor: pointer;
            }

        }
    }
    @media screen and (min-width: 992px){
        #user_info{
            .infos{
                height: auto;
            }   
        }
    }
</style>
